<template>
  <div class="categorycheckbox">
    <div class="categorycheckbox__container">
      <div class="wrap-collapsible" v-show="inputEnabled">
        <input :id="inputId" :name="inputId" :checked="inputEnabled" type="checkbox" class="toggle" />
        <label :for="inputId" class="lbl-toggle">{{ inputValue }}</label>
        <div class="collapsible-content">
          <div class="content-inner">
            <router-link :to="'/app/'+appName.replace(' ','')+'/'+inputValue+'/'+getFirtLanguage()">
              <h2>Open Document</h2>
            </router-link>
            <h3>Languages Available:</h3>
            <div class="content-inner__groups">
              <div class="group-lang" v-for="(item, key) in documentLanguages" :key="key">
                <input
                  type="checkbox"
                  class="input_language"
                  :name="item"
                  :id="item + '_' + inputValue"
                  checked
                  @change="showSaveButton($event)"
                />
                <label :for="item + '_' + inputValue" class="lbl-toggle">{{ getLanguageName(item) }}</label>
                <!-- <TheAddNewModal :modalId="'modal_'+item + '_' + inputValue" :modalType="inputValue" :modalTitle="'Add New Language for '+documentType" modalName="Language" modalData="language" :showModal="showAddModal"  @close="closeModal()" /> -->
              </div>
              <div class="group-lang">
                <TheAddNewModal
                  :modalId="'modal_' + inputValue"
                  :modalType="inputValue"
                  :modalTitle="'Add New Language for '+ inputValue"
                  modalName="Language"
                  modalData="language"
                  :showModal="showAddModal"
                  :documentLanguages="documentLanguages"
                  @close="closeModal()"
                />
                <button
                  @click="addNewLanguage()"
                  name="addNewLanguage"
                  id="addNewLanguage"
                  class="add_btn"
                >
                  <i class="material-icons">add_circle</i>
                  <span class="title">Add Language</span>
                </button>
              </div>
              <div class="group-lang">
                <button
                  @click="saveLanguages()"
                  v-show="showSaveLanguages"
                  name="saveLanguages"
                  id="saveLanguages"
                  class="saveLang_btn"
                >
                  <i class="material-icons">save</i>
                  <span class="title">Save Language Changes</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appMutations, appActions } from '@/constants/'
import ApiService from '@/services/ApiService'
import TheAddNewModal from '@/components/TheAddNewModal'

const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'thecategorycheckbox',
  components: {
    TheAddNewModal
  },
  props: {
    inputId: Number,
    inputValue: String,
    inputEnabled: Boolean
  },
  data: function () {
    return {
      apiService: new ApiService(),
      allDocuments: null,
      documentLanguages: null,
      documentType: null,
      showAddModal: false,
      addNewWasClicked: false,
      checkedLanguages: [],
      showSaveLanguages: false,
      currentCategory: ''
    }
  },
  mounted () {
    this.loadDocuments()
    this.$store.subscribe(mutation => {
      if (mutation.type === 'applicationState/' + appMutations.SET_APP_SETTINGS_DOCUMENT_LIST) {
        this.loadDocuments()
      }
    })
  },
  methods: {
    getFirtLanguage () {
      let ret = 'de'
      if (this.documentLanguages != null && this.documentLanguages.length > 0) {
        ret = this.documentLanguages[0]
      }
      return ret
    },
    loadDocuments (ifAppExists) {
      //   if(ifAppExists === undefined){
      this.allDocuments = this.appDocumentList
      this.documentLanguages = this.appDocumentList.filter(
        item => item.documentId === this.inputId
      )[0].languages
      this.documentType = this.appDocumentList.filter(
        item => item.documentId === this.inputId
      )[0].title
      this.checkedLanguages = this.documentLanguages.map(val => val) // shallow copy the current languages in the server, to save later
      //   }
    },
    getLanguageName (lang) {
      return this.$i18n.messages[lang].message.languageFullName === undefined
        ? 'unknown'
        : this.$i18n.messages[lang].message.languageFullName
    },
    showSaveButton (evt) {
      // have a temp array of the languages to know the original state of checked/unchecked languages
      //   var tempLanguages = this.checkedLanguages.map(val => val);
      let isLanguageFound = false
      //   console.log("this.checkedLanguages.length = " + this.checkedLanguages.length, this.checkedLanguages)
      // search for it on the array
      for (let i = 0; i < this.documentLanguages.length; i++) {
        // flag it that you found it and break the loop
        if (this.documentLanguages[i] === evt.target.name) {
          isLanguageFound = true
          break
        }
      }

      if (evt.target.checked) {
        // if the language is checked...

        // ...and the language is not found, then push it in the checkedLanguages array, show the save button
        if (!isLanguageFound) {
          this.checkedLanguages.push(evt.target.name)
          this.showSaveLanguages = true
        } else {
          this.showSaveLanguages = false
          // ...and the language is found, make sure is in the checkedLanguages array
          let isMissing = false
          for (let i = 0; i < this.checkedLanguages.length; i++) {
            if (this.checkedLanguages[i] === evt.target.name) {
              isMissing = true
            } else {
              isMissing = false
            }
          }

          // console.log('isMissing: ', isMissing)
          if (isMissing) {
            this.checkedLanguages.push(evt.target.name)
            this.showSaveLanguages = true
          } else {
            // ...do nothing
          }
        }
      } else {
        // if the language is not checked...

        // ...and the language is found, remove it from the checkedLanguages array
        if (isLanguageFound) {
          for (let i = 0; i < this.checkedLanguages.length; i++) {
            // remove it from the array
            if (this.checkedLanguages[i] === evt.target.name) {
              this.checkedLanguages.splice(i, 1)
              break
            }
          }
          // show the save button changes
          this.showSaveLanguages = true
        } else {
          // ...and the language is not found, do nothing, hide the save button changes
          this.showSaveLanguages = false
        }
      }
    },
    saveLanguages () {
      let updateDocumentList = this.appDocumentList.map(val => val) // shallow copy all documents
      let currentDocument = updateDocumentList.filter(
        item => item.documentId === this.inputId
      )[0]
      currentDocument.languages.length = 0
      currentDocument.languages = this.checkedLanguages

      this.$store.dispatch(
        'applicationState/' + appActions.UPDATE_APP_SETTINGS_DOCUMENT_LIST,
        {
          name: this.appName,
          data: this.appDocumentList,
          document: currentDocument
        }
      )

      // Subscribe to the mutation in case another component modifies the state
      this.$store.subscribe(mutation => {
        if (
          mutation.type ===
          'applicationState/' + appMutations.SET_APP_SETTINGS_DOCUMENT_LIST
        ) {
          // if the mutation was successful then hide the button
          this.showSaveLanguages = false
          this.loadDocuments()
        }
      })
    },
    addNewLanguage () {
      this.showAddModal = true
      // console.log(this.showAddModal)
      this.addNewWasClicked = true
    },
    closeModal () {
      this.showAddModal = false
    }
  },
  computed: {
    ...mapState({
      appName: state => state.appName,
      appDocumentList: state => state.appDocumentList
    })
  },
  watch: {
    appDocumentList (newV, oldV) {
      // console.log(`thecategorycheckbox appDocumentList: newV: ${newV.length} | oldV: ${oldV.length}`);
    },
    appName (newV, oldV) {
      // console.log(`thecategorycheckbox appName: newV: ${newV} | oldV: ${oldV}`);
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/main.scss";

.categorycheckbox {
  &__container {
    .wrap-collapsible {
      margin: auto rem(12) rem(12) rem(12);

      input[type="checkbox"] {
        display: none;
      }
      .lbl-toggle {
        display: block;
        font-family: $font-stack;
        font-size: rem(16);
        text-align: center;
        padding: rem(16);
        color: $light;
        background: rgba($primary, 0.8);
        cursor: pointer;
        border-radius: rem(5);
        transition: all 0.25s ease-out;

        &:hover {
          font-weight: $font-bold;
          color: $light;
        }

        &:before {
          content: " ";
          display: inline-block;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 5px solid rgba($light, 1);
          vertical-align: middle;
          margin-right: rem(12);
          transform: translateY(-2px);
          transition: transform 0.2s ease-out;
        }
      }

      .collapsible-content {
        max-height: 0px;
        overflow: hidden;
        transition: max-height 0.25s ease-in-out;
        .content-inner {
          background: rgba($light-dark, 0.2);
          border-bottom: 1px solid rgba($dark-light, 0.45);
          border-bottom-left-radius: rem(5);
          border-bottom-right-radius: rem(5);
          padding: rem(10) rem(16);

          &__groups {
            display: flex;
            flex-flow: row wrap;
            justify-content: start;
            margin: rem(4) auto;
            .group-lang {
              background-color: transparent;
              display: inline-block;
              margin: rem(4);
              position: relative;
              max-width: rem(180);
              label:not(.v-label) {
                padding: rem(10) rem(12) rem(10) rem(28);
                width: 100%;
                display: block;
                text-align: left;
                color: $light;
                cursor: pointer;
                position: relative;
                z-index: 2;
                transition: color 200ms ease-in;
                overflow: hidden;
                font-size: rem(12);
                background-color: $light-dark;
                &:before {
                  width: rem(10);
                  height: rem(10);
                  border-radius: 50%;
                  content: "";
                  background-color: $primary;
                  position: absolute;
                  left: 10%;
                  top: 50%;
                  transform: translate(-40%, -50%) scale3d(1, 1, 1);
                  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
                  opacity: 0;
                  z-index: -1;
                }
                &:after {
                  width: rem(14);
                  height: rem(14);
                  content: "";
                  border: 1px solid $dark-light;
                  background-color: $light;
                  background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
                  background-repeat: no-repeat;
                  background-position: -1px -1px;
                  border-radius: 50%;
                  z-index: 2;
                  position: absolute;
                  left: rem(5);
                  top: 50%;
                  transform: translateY(-50%);
                  cursor: pointer;
                  transition: all 200ms ease-in;
                }
              }
              input[type="checkbox"]:checked ~ label {
                color: $light;
                &:before {
                  background-color: $primary;
                  transform: translate(-50%, -50%) scale3d(56, 56, 1);
                  opacity: 1;
                }
                &:after {
                  background-color: $secondary;
                  border-color: $secondary;
                }
              }
              input[type="checkbox"] {
                width: rem(20);
                height: rem(20);
                order: 1;
                z-index: 2;
                position: absolute;
                right: rem(20);
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                visibility: hidden;
              }

              .add_btn {
                display: block;
                font-family: $font-stack;
                font-size: rem(12);
                text-align: center;
                margin: 0;
                padding: rem(4) rem(8) rem(4) rem(4);
                color: $light;
                background: rgba($light, 0.8);
                cursor: pointer;
                border-radius: rem(5);
                border: 1px solid $light-dark;
                transition: all 0.25s ease-out;

                .title {
                  color: $primary;
                  margin-left: rem(28);
                  font-size: rem(12);
                }
                .material-icons {
                  position: absolute;
                  color: rgba($primary, 1);
                  font-size: rem(24);
                }

                &:hover {
                  font-weight: $font-bold;
                  color: $light;
                }
              }

              .saveLang_btn {
                display: block;
                font-family: $font-stack;
                font-size: rem(12);
                text-align: center;
                margin: 0;
                padding: rem(4) rem(8) rem(4) rem(4);
                color: $light;
                background: rgba($save, 0.8);
                cursor: pointer;
                border-radius: rem(5);
                border: 1px solid $light-dark;
                transition: all 0.25s ease-out;

                .title {
                  color: $light;
                  margin-left: rem(28);
                  font-size: rem(12);
                }
                .material-icons {
                  position: absolute;
                  color: rgba($light, 1);
                  font-size: rem(24);
                }

                &:hover {
                  font-weight: $font-bold;
                  color: $light;
                }
              }
            }
          }
        }
      }

      .toggle:checked + .lbl-toggle + .collapsible-content {
        // Results in 125rem with base font size of 16px. Before: 21,875rem
        // Still not perfect, cause not dynamicly calculated based on the scroll height.
        // But this is a quick fix.
        // In case some one assigned to this project and with local setup running sees this:
        // Here is your TODO: Optimize.
        // Greetings, Lars on 9th September 2021
        max-height: rem(2000);
      }

      .toggle:checked + .lbl-toggle::before {
        transform: rotate(90deg) translateX(-3px);
      }

      .toggle:checked + .lbl-toggle {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
